import React, { useEffect, useRef, useState } from "react";
import phoneFrame from "./assets/nokia.png";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

export default function PhoneViewer({ images }) {
  const [i, setI] = useState(0);
  const [lightbox, setLightbox] = useState(false);
  const lastTapRef = useRef(0);

  const next = () => setI(n => (n + 1) % images.length);
  const prev = () => setI(n => (n - 1 + images.length) % images.length);

  useEffect(() => { images.forEach(src => { const img = new Image(); img.src = src; }); }, [images]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowRight") next();
      else if (e.key === "ArrowLeft") prev();
      else if (e.key === "Escape") setLightbox(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const handleScreenClick = () => {
    const now = Date.now();
    if (now - lastTapRef.current < 280) setLightbox(true);
    lastTapRef.current = now;
  };

  return (
    <>
      <div className="phone-wrap">
  <img className="phone-frame" src={phoneFrame} alt="" draggable="false" />

      <div
        className="phone-screen"
        onDoubleClick={() => setLightbox(true)}
        onClick={handleScreenClick}
      >
        <img className="phone-photo" src={images[i]} alt="" />
      </div>

      {/* NEW: anchor to the screen box */}
      <div className="phone-arrows" role="group" aria-label="Photo navigation">
        <button
          className="phone-arrow left"
          onClick={(e)=>{ e.stopPropagation(); prev(); }}
          aria-label="Previous"
        >
          <FiChevronLeft />
        </button>
        <button
          className="phone-arrow right"
          onClick={(e)=>{ e.stopPropagation(); next(); }}
          aria-label="Next"
        >
          <FiChevronRight />
        </button>
      </div>
    </div>


      {lightbox && (
        <div className="lightbox" onClick={() => setLightbox(false)}>
          <img src={images[i]} alt="" />
        </div>
      )}
    </>
  );
}
